module.exports = ".color-red {\r\n    color: red;\r\n}\r\n\r\n.cursor {\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/role-specific/superadmin/templates/templates.component.css
// module id = ./src/app/pages/role-specific/superadmin/templates/templates.component.css
// module chunks = main